import dayjs from '~/timeInit';

import { HeatmapSurchargeRoomNight } from '~/types/heatmapSurcharge';

export function getForecast(roomNight: HeatmapSurchargeRoomNight) {
  const { predictedFinalBookings, predictedRoomsLeft, forecastExceedsAllocationBy } = roomNight;
  if (predictedFinalBookings == null || predictedRoomsLeft == null || forecastExceedsAllocationBy == null) return null;

  return {
    finalBookings: predictedFinalBookings,
    roomsLeft: predictedRoomsLeft,
    exceedsAllocationBy: forecastExceedsAllocationBy,
  };
}

/** Include empty cells around the month so every week starts on Monday. */
export function getMonthCells(month: string): Array<string | null> {
  const start = dayjs(`${month}-01`);
  const leadingDays = (start.day() + 6) % 7;
  const dates = Array.from({ length: start.daysInMonth() }, (_, index) => start.add(index, 'day').format('YYYY-MM-DD'));
  const trailingDays = (7 - ((leadingDays + dates.length) % 7)) % 7;
  return [...Array<string | null>(leadingDays).fill(null), ...dates, ...Array<string | null>(trailingDays).fill(null)];
}

export function formatCount(value: number | null) {
  return value == null ? 'Unknown' : value.toLocaleString('en-AU', { maximumFractionDigits: 2 });
}

export function formatMonth(month: string) {
  return dayjs(`${month}-01`).format('MMMM YYYY');
}

export function isMatchingPdf(forecastGeneratedAt: string, pdfGeneratedAt: string, expiresAt: string, now = dayjs()) {
  return dayjs(forecastGeneratedAt).isSame(dayjs(pdfGeneratedAt)) && dayjs(expiresAt).isAfter(now);
}
